import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { RequiredItem } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import {
  MULTI_ORG_CHILD,
  MULTI_ORG_PARENT,
} from "../../../constants/organization-types";

import {
  IntegrationIdp,
  OrgExpirationDateEditor,
  OrgFormToggle,
  OrgIntegrationExtIdEditor,
  OrgProductsEditor,
  OrgSelectMenuEditor,
  OrgSimsEditor,
  OrgTraineeLimitEditor,
  OrgTrekCareersEditor,
  OrgTrekLicensesEditor,
} from "../../../components/forms/org-editor";
import { OrgProgramsEditor } from "../../../components/forms/org-editor/org-programs.editor";
import { SingleOrgSelect } from "../../../components/forms/single-org-select";

export function OrgDetailEditor({
  childrenData,
  parentData,
  tsMenus,
  sims,
  trekCareers,
  selectedType,
  idpList,
  programs,
}) {
  const [showTSMenu, setShowTSMenu] = useState();
  const [showSims, setShowSims] = useState();
  const [showTrek, setShowTrek] = useState();
  const [showTrekSelection, setShowTrekSelection] = useState();
  const [showProgramsSelection, setShowProgramsSelection] = useState();
  const { control, setValue, watch } = useFormContext();
  const productsWatch = watch("products");
  const integrationsWatch = watch("integrations");
  const orgIdpWatch = watch("orgIdp");
  const integrationExternalIdWatch = watch("integrationExternalId");
  const showRosterSync =
    integrationsWatch && !!orgIdpWatch?.id && !!integrationExternalIdWatch;

  const onOrgSelected = async (org) => {
    setValue("parent", org);
  };

  useEffect(() => {
    setShowTSMenu(productsWatch?.find((p) => p.id === Product.TS));
    setShowSims(productsWatch?.find((p) => p.id === Product.CE));
    setShowTrek(productsWatch?.find((p) => p.id === Product.TRK));
    setValue("allSims", true);
    setShowTrekSelection(productsWatch?.find((p) => p.id === Product.TRK));
    setValue("allCareers", true);
    setShowProgramsSelection(productsWatch?.find((p) => p.id === Product.PROG));
  }, [productsWatch]);

  return (
    <div className="org-detail-editor">
      {selectedType.id == MULTI_ORG_PARENT.id ? (
        <div>
          <div className="section-title">Organization&apos;s Children</div>
          <Controller
            control={control}
            name="children"
            defaultValue={[]}
            render={({ field: { onChange, value } }) => {
              return (
                <SingleOrgSelect
                  selectedOrgs={value}
                  onChange={onChange}
                  placeholder={
                    "Select one or more existing child organizations..."
                  }
                  data={childrenData}
                />
              );
            }}
          />
        </div>
      ) : (
        <div>
          {selectedType.id == MULTI_ORG_CHILD.id && (
            <>
              <div className="section-title">
                <RequiredItem text="Organization's Parent" />
              </div>
              <Controller
                control={control}
                rules={{ required: true }}
                name="parent"
                render={({ field: { value } }) => {
                  return (
                    <Dropdown
                      className="org-dropdown"
                      selected={value}
                      onOptionSelected={onOrgSelected}
                    >
                      <DropdownButton
                        placeholder={"Select an organization..."}
                        icon={"fa-light fa-sitemap"}
                      >
                        {value?.name}
                      </DropdownButton>
                      <DropdownItems>
                        {parentData.map((org) => (
                          <DropdownItem key={org.code} value={org}>
                            {org.name}
                          </DropdownItem>
                        ))}
                      </DropdownItems>
                    </Dropdown>
                  );
                }}
              />
            </>
          )}
          <OrgProductsEditor />
          {showTSMenu && (
            <div>
              <OrgSelectMenuEditor menus={tsMenus} />
            </div>
          )}
          <OrgFormToggle
            name="integrations"
            title="Integrations"
            infoText="Would you like to enable external integrations?"
          />
          <IntegrationIdp idpList={idpList} />
          <OrgIntegrationExtIdEditor />
          {showRosterSync && (
            <OrgFormToggle
              name="rosterSyncEnabled"
              title="Enable Roster Sync"
              infoText="Enable synchronization of rostering data."
            />
          )}
          <OrgFormToggle
            name="ssoEnabled"
            title="Enable Single Sign-On"
            infoText="Enable sign on with your organization credentials."
          />
          {showSims && <OrgSimsEditor required data={sims} />}
          {showTrekSelection && (
            <OrgTrekCareersEditor required data={trekCareers} />
          )}
          {showProgramsSelection && (
            <OrgProgramsEditor required data={programs} />
          )}
          <OrgTraineeLimitEditor name="traineeLimit" />
          {showTrek && <OrgTrekLicensesEditor name="trekLicenses" />}
          <OrgExpirationDateEditor />
        </div>
      )}
    </div>
  );
}
